import { Inject, Injectable, Optional, PLATFORM_ID } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';
import { HttpClient } from '@angular/common/http';
import { Subscription, firstValueFrom } from 'rxjs';
import { EventEmitter } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { isPlatformServer } from '@angular/common';


export interface Consent {
  id: string;
  state: ConsentState;
  timestamp: number;
}

export enum ConsentState {
  GRANTED, DENIED
}

@Injectable({providedIn: 'root'})
export class ConsentService {

  private static CONSENT = "listx_consent";
  
  private _onConsent = new EventEmitter();

  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
 	  @Inject('API_URL') private apiContext: string,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Optional() @Inject('REQUEST') private request: any
    ) {
  }
  
  getConsentState(): ConsentState | null {
    
    const consent = this.getConsent();
    
    return consent ? consent.state : null;
  }
  
  getConsent(): Consent | undefined {
    
    let storedConsentString: string | undefined;

    if (isPlatformServer(this.platformId) && this.request && this.request.cookies) {
      storedConsentString = this.request.cookies[ConsentService.CONSENT];
    } else {
      storedConsentString = this.cookieService.get(ConsentService.CONSENT);
    }
    
    return storedConsentString ? JSON.parse(storedConsentString) : undefined;
  }
  
  grantConsent() {
    this.storeConsent(ConsentState.GRANTED);
  }
  
  onConsent(callback: (consent: Consent) => void): Subscription {
    console.log("Subscribing for onConsent");
    return this._onConsent.subscribe(callback);
  }
  
  private storeConsent(state: ConsentState) {
    
    const consent = {
      id: uuidv4(),
      state: state,
      timestamp: Date.now()
    } as Consent

    this.setConsentCookie(consent);    
    this.createConsentRecord(consent);
    console.log("Firing onConsent");
    this._onConsent.emit(consent);
  }
  
  private setConsentCookie(consent: Consent) {
    const expires = new Date();
    expires.setFullYear(expires.getFullYear() + 2);
    this.cookieService.set(ConsentService.CONSENT, JSON.stringify(consent), expires, '/');
  }
  
  denyConsent() {
    this.storeConsent(ConsentState.DENIED);
  }
  
  private createConsentRecord(consent: Consent): Promise<void> {
     return firstValueFrom(this.http.post<void>(`${this.apiContext}/consents`, consent));
  }
}